import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import FlexRow from "../../../components/base/FlexRow";
import ScrollContainer from "../../../components/base/ScrollContainer";
import Section from "../../../components/base/Section";
import Layout from "../../../components/layouts/Layout";
import CRMSideMenu, { useCRMSideMenuItems } from "./CRMSideMenu";
import { clearPageName, useScreen } from "../../../core/Global";
import PageTitleBar from "../../../components/layouts/header/PageTitleBar";
import { getFirstAccessibleLink, useModuleLastPage } from "../../../components/layouts/aside/useModuleLastPage";
import ModuleSidebar from "../../../components/layouts/aside/ModuleSidebar";


export default function CRMMainView() {

    const screen = useScreen()
    const location = useLocation()
    const sideMenuItems = useCRMSideMenuItems()
    const defaultLink = getFirstAccessibleLink(sideMenuItems, "/crm/jobs/all") ?? "/crm/jobs/all"
    useModuleLastPage("/crm", defaultLink)

    useEffect(() => {
        return () => {
            clearPageName()
        }
    }, [location.pathname])

    return (
        <Layout wide noToolbar paddingBottom={0} paddingTop={0}>
            <Section fluid fit>
                <FlexRow alignItems="start">

                    {
                        !screen.isMobile &&
                        <ModuleSidebar storageKey="rinvox-sidebar-collapsed-crm">
                            <CRMSideMenu />
                        </ModuleSidebar>
                    }

                    <div className="flex-row-fluid">

                        <PageTitleBar />

                        <ScrollContainer>
                            <Outlet />
                        </ScrollContainer>

                    </div>

                </FlexRow>
            </Section>
        </Layout>
    )
}
